// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nQi3","selected":"styles_selected___b_NZ"};